<template>
  <div class="app-container goods-list">
    <div class="goods-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="goods-list-filter-value" v-model.trim="search.keywords" @keyup.enter.native="searchChange" placeholder="商品名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-list-filter-value" placeholder="商品分类" v-model="search.goodsType" clearable filterable size="small">
              <el-option
                v-for="item in search.goodsTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
              <el-input class="goods-list-filter-value" v-model.trim="search.minDiscount" @keyup.enter.native="searchChange" placeholder="价格高于" clearable size="small"></el-input>
              -
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
              <el-input class="goods-list-filter-value" v-model.trim="search.maxDiscount" @keyup.enter.native="searchChange" placeholder="价格低于" clearable size="small"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-list-filter-value" placeholder="核销类型" v-model="search.redeemType" clearable size="small">
              <el-option
                v-for="item in redeemTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="goods-list-filter-value" placeholder="是否已下架" v-model="search.isBannedGoods" clearable size="small">
              <el-option
                v-for="item in bannedGoodsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <div>
            <el-button class="goods-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="goods-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "goods-list-container">
      <avue-crud ref="crud"
                 :option="goodsTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.goods_add">新增商品</el-button>
          <el-button type="primary" @click="handleSyncCache" icon="el-icon-refresh" size="small" v-if="permissions.goods_cache_sync">同步</el-button>
        </template>

        <template slot="name"
                  slot-scope="scope">
          <div class="preview">
            <div class="goods-cover-image" v-if="scope.row.coverImg" v-viewer>
              <img :src="scope.row.coverImg">
              <img v-for="(src, index) in scope.row.attachments" :key="index" :src="src.attachmentUrl" :class="{'hide-redundant-goods-images': index > -1 }">
            </div>
            <a href="javascript:void(0);" @click="handleDetail(scope.row,scope.index);"
                class="goods-list-container-button">
              {{scope.row.name}}
            </a>
          </div>
        </template>
        <template slot="explainSku"
                  slot-scope="scope">
          {{scope.row.explainSku}}
        </template>

        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_edit"
                     @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_down && !scope.row.isBanned"
                     @click="handleDown(scope.row,scope.index)">下架
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_up && scope.row.isBanned"
                     @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_top && (scope.row.sort == 0 || page.currentPage != 1 || scope.index != 0)"
                     @click="handleTop(scope.row,scope.index)">置顶
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_top && scope.row.sort > 0 && page.currentPage == 1 && scope.index == 0"
                     @click="handleCancelTop(scope.row,scope.index)">取消置顶
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.goods_sku_edit"
                     @click="openSkuDialog(scope.row,scope.index)">修改库存
          </el-button>
        </template>

      </avue-crud>
    </basic-container>

    <el-dialog
      title="编辑库存"
      :visible.sync="skuDialogVisible"
      width="30%">
      <template>
        <div>
          <label class="sku-input-label">修改库存</label>
          <el-input-number
            v-model="skuValue"
            :step="1"
            :min="0"
            oninput="value = Number(value) || 0"
            @change="checkSkuValue()">
          </el-input-number>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="skuDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateSku()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banComment"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchGoodsList,updateSkuValue,updateGoodsTopStatus,updateGoodsBanStatus,syncGoodsCache} from '@/api/mall/goods';
  import {fetchGoodsTypeList} from '@/api/mall/type';
  import {goodsTableOption, redeemTypeOptions} from '@/const/crud/mall/goods';
  import {goodsRedeemTypesEnum} from '@/common/enums/mallTypeEnum';
  import {mapGetters} from "vuex";

  export default {
    name: "table_goods",
    data() {
      return {
        redeemTypeOptions,
        bannedGoodsOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        search: {
          current: 1,
          size: 10,
          minDiscount: "",
          maxDiscount: "",
          redeemType: "",
          isBannedGoods: "",
          keywords: "",
          sortField: "",
          sortPolicy: "",
          goodsType: "",
          goodsTypeOptions: [],
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
        goodsTableOption: goodsTableOption,
        skuDialogVisible: false,
        skuValue: 0,
        banDialogVisible: false,
        banGoodsId: 0,
        banComment: "",
      };
    },
    async activated() {
      await this.getGoodsTypeOptions();
      this.getList();
    },
    async created () {
      await this.getGoodsTypeOptions();
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      formatData(records) {
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if(!record.name) {
              record.name = "--"
            }
            if(!record.description) {
              record.description = "--"
            }
            if (!record.goodsTypes) {
              record.goodsTypes = "--"
            }
            if (!record.redeemType) {
              record.redeemType = "其他"
            } else if (record.redeemType == goodsRedeemTypesEnum.ONLINE.code) {
              record.redeemType = goodsRedeemTypesEnum.ONLINE.type
            } else if (record.redeemType == goodsRedeemTypesEnum.OFFLINE.code) {
              record.redeemType = goodsRedeemTypesEnum.OFFLINE.type
            } else if (record.redeemType == goodsRedeemTypesEnum.VIRTUAL.code) {
              record.redeemType = goodsRedeemTypesEnum.VIRTUAL.type
            } else {
              record.redeemType = goodsRedeemTypesEnum.PHYSICAL_EXCHANGE.type
            }
            if (!record.remainSku && record.remainSku != 0) {
              record.remainSku = record.sku
              record.explainSku = 0
            } else {
              record.explainSku = record.sku - record.remainSku
            }
            if (!record.usageNote) {
              record.usageNote = "--"
            }
            if (!record.banComment){
              record.banComment = "--"
            }
            record.isNotBanned = record.isBanned ? '已下架' : '正常';
            record.goodsTypes = record.goodsTypes.map(item => {return item.typeName}).join('、');
          })
        }
        return records
      },
      getList() {
        let params = {
          current: this.search.current,
          size: this.search.size
        }

        if (this.search.minDiscount != "" && this.search.minDiscount.trim() != "")
          params.minDiscount = this.search.minDiscount;
        if (this.search.maxDiscount != "" && this.search.maxDiscount.trim() != "")
          params.maxDiscount = this.search.maxDiscount;
        if (this.search.keywords != "" && this.search.keywords.trim() != "")
          params.name = this.search.keywords;
        if (this.search.isBannedGoods !== null && this.search.isBannedGoods !== "")
          params.isBanned = this.search.isBannedGoods;
        if (this.search.redeemType !== null && this.search.redeemType !== "")
          params.redeemType = this.search.redeemType;
        if (this.search.goodsType !== null && this.search.goodsType !== "" && this.search.goodsType !== -1) {
          params.goodsType = this.search.goodsType;
        }

        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField;
        else
          params.sortField = "inserted_time"
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy;
        else
          params.sortPolicy = "desc";

        this.tableLoading = true;
        fetchGoodsList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records);
          this.page.total = response.data.data.total;
          this.tableLoading = false;
        })
      },
      initPage() {
        this.page.currentPage = 1;
        this.page.pageSize = this.search.size;
        this.search.current = 1;
      },
      async getGoodsTypeOptions() {
        const response = await fetchGoodsTypeList();
        if (Array.isArray(response.data.data)) {
          const type = response.data.data.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          });
          this.search.goodsTypeOptions = [{value: -1, label: '全部'}].concat(type);
        }
      },
      searchChange() {
        this.initPage();
        this.getList();
      },
      searchReset() {
        this.search.keywords = "";
        this.search.minDiscount = "";
        this.search.maxDiscount = "";
        this.search.goodsType = "";
        this.search.redeemType = "";
        this.search.isBannedGoods = "";
        this.searchChange();
      },
      handleCurrentChange(val) {
        this.page.currentPage = val;
        this.search.current = val;
        this.getList();
      },
      handleSizeChange(val) {
        this.page.pageSize = val;
        this.search.size = val;
        this.getList();
      },
      handleSortChange(val) {
        if (val.prop == "rewardValue") {
          this.search.sortField = "reward_value";
        } else if (val.prop == "discount") {
          this.search.sortField = "discount";
        } else if (val.prop == "sku") {
          this.search.sortField = "sku";
        } else if (val.prop == "explainSku") {
          this.search.sortField = "explainSku";
        } else if (val.prop == "remainSku") {
          this.search.sortField = "remainSku";
        } else {
          this.search.sortField = "";
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc";
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc";
        } else {
          this.search.sortPolicy = "";
        }
        this.getList();
      },
      handleOpenBefore(show, type) {
        show();
      },
      openSkuDialog(row) {
        this.skuDialogVisible = true;
        this.skuValue = row.sku;
        this.goodsId = row.id;
      },
      checkSkuValue() {
        if (this.skuValue > 99999999) {
          this.$message({
            showClose: true,
            message: '库存范围为0-99999999',
            type: 'error'
          })
        }
      },
      updateSku() {
        let params = {
          id: '',
          sku: '',
        }
        params.id = this.goodsId;
        params.sku = this.skuValue;
        if (this.skuValue > 99999999) {
          this.$message({
            showClose: true,
            message: '库存范围为0-99999999',
            type: 'error'
          })
          return;
        }
        updateSkuValue(params).then((res) => {
          if (res.data.data) {
            this.skuDialogVisible = false;
            this.getList();
          }
        })
      },
      handleTop(row) {
        let params = {
          id : row.id,
          isTop : true
        }
        this.$confirm('是否将商品置顶？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          updateGoodsTopStatus(params).then(response => {
            if (response.data.data) {
              this.$message({
                message: '置顶成功',
                type: 'success'
              })
              this.getList();
            }
          }).catch(error => {
            this.$message({
              message: '置顶失败',
              type: 'error'
            })
          })
        })
      },
      handleCancelTop(row) {
        let params = {
          id : row.id,
          isTop : false
        }
        this.$confirm('是否将商品取消置顶？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          updateGoodsTopStatus(params).then(response => {
            if (response.data.data) {
              this.$message({
                message: '取消置顶成功',
                type: 'success'
              })
              this.getList();
            }
          }).catch(error => {
            this.$message({
              message: '取消置顶失败',
              type: 'error'
            })
          })
        })
      },
      handleUp(row, index) {
        let params = {
          id : row.id,
          isBanned : false
        }
        this.$confirm('是否将商品上架？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateGoodsBanStatus(params).then(response => {
            if (response.data.data) {
              this.$message({
                message: '上架成功',
                type: 'success'
              })
              this.getList();
            }
          }).catch(error => {
            this.$message({
              message: '上架失败',
              type: 'error'
            })
          })
        })
      },
      handleDown(row, index) {
        this.banGoodsId = row.id;
        this.banComment = "";
        this.banDialogVisible = true;
      },
      handleDownSubmit() {
        if (!this.banComment) {
          this.$message({
            showClose: true,
            message: '下架原因不能为空',
            type: 'error'
          });
          return;
        }
        let params = {
          id : this.banGoodsId,
          isBanned : true,
          banComment : this.banComment
        }
        this.$confirm('是否将商品下架？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateGoodsBanStatus(params).then(response => {
            if (response.data.data) {
              this.$message({
                message: '下架成功',
                type: 'success'
              })
              this.banDialogVisible = false;
              this.getList();
            }
          }).catch(error => {
            this.$message({
              message: '下架失败',
              type: 'error'
            })
          })
        })
      },
      handleAdd() {
        this.$router.push({ path: '/mall/goods/add' });
      },
      handleEdit(row, index) {
        if (row.id){
          this.$router.push({
            path: `/mall/goods/edit/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该商品不存在',
            type: 'warning'
          })
        }
      },
      handleDetail(row, index) {
        if (row.id){
          this.$router.push({
            path: `/mall/goods/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该商品不存在',
            type: 'warning'
          })
        }
      },
      handleSyncCache() {
        var _this = this;
        _this.$confirm('请确认是否需要同步商品缓存？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(function () {
          return syncGoodsCache();
        }).then(() => {
          _this.$message({
            showClose: true,
            message: '同步成功',
            type: 'success',
          });
        }).catch(function (err) {
          if (err == 'cancel') {
            return;
          }
          _this.$message({
            showClose: true,
            message: '同步失败',
            type: 'error',
          });
        });
      },
    }
  };

</script>


<style lang="scss" scoped>

.goods-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.preview {
  display: flex;
  align-items: center;
  .goods-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.sku-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}
.hide-redundant-goods-images {
  display: none;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
